"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chains = exports.rawChains = void 0;
const kusama_chains_1 = require("./kusama-chains");
const polkadot_chains_1 = require("./polkadot-chains");
exports.rawChains = 
// TODO switch this to an enum
process.env.network === "mainnet"
    ? {
        ...kusama_chains_1.kusamaChains,
        ...polkadot_chains_1.polkadotChains,
    }
    : {
        ...kusama_chains_1.kusamaTestnetChains,
        ...polkadot_chains_1.polkadotTestnetChains,
    };
exports.chains = exports.rawChains;
